import { cx } from 'emotion';
import {
  arrayOf, shape, oneOfType, number, string, func, object, any,
} from 'prop-types';
import React from 'react';

import { getThemeColor } from '@ezugi/ui/theme';

import Icon from '../Icon/Icon';
import {
  Container, Option, activeClassName, Label,
} from './style';

export default function Switcher({ options, onChange, active, ...props }) {
  const isActive = ({ value }) => active === value;
  return (
    <Container {...props}>
      {options.map((option, i) => (
        <Option
          key={option.id || i}
          onClick={() => onChange(option.value)}
          data-active={isActive(option)}
          className={cx(isActive(option) && activeClassName)}
        >
          {option.icon && (
            <Icon
              svg={option.icon}
              {...(isActive(option) ? { color: getThemeColor('primaryContrast') } : {})}
            />
          )}
          <Label>
            {option.label}
          </Label>
        </Option>
      ))}
    </Container>
  );
}

const optionType = shape({
  id: oneOfType([ number, string ]),
  label: string,
  // eslint-disable-next-line react/forbid-prop-types
  value: any.isRequired,
  icon: oneOfType([ string, object ]),
});

Switcher.propTypes = {
  options: arrayOf(optionType),
  onChange: func,
  active: string,
};

Switcher.defaultProps = {
  options: [],
  onChange: () => {},
};
